import { render, staticRenderFns } from "./ParentControlProgramForm.vue?vue&type=template&id=8d60afae&scoped=true&"
import script from "./ParentControlProgramForm.vue?vue&type=script&lang=js&"
export * from "./ParentControlProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d60afae",
  null
  
)

export default component.exports